import React, { useState } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import SelfManagedSupplierInvitationForm from '../self_managed_supplier_invitation_form/SelfManagedSupplierInvitationForm';
import { inviteSupplierUserFromBuyer } from '../../thunks/supplier_private_networks_thunks';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

interface InviteValues {
	primaryContactEmail: string;
	primaryContactFirstName: string;
	primaryContactLastName: string;
}

interface Props {
	visible: boolean;
	supplierFacility: any;
	onCancel?: () => void;
	onSkip?: () => void;
	onInvited: (values: InviteValues) => void;
	currentUser: any;
	userType: string;
	showContext?: boolean;
	inviteSupplierUser: (
		supplierFacilityId: number,
		fromEmail: string,
		toEmail: string,
		firstName: string,
		lastName: string
	) => Promise<any>;
}

const SelfManagedSupplierEmailPromptModal: React.FC<Props> = ({
	visible,
	supplierFacility,
	onCancel,
	onSkip,
	onInvited,
	currentUser,
	inviteSupplierUser,
	showContext,
}) => {
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = (values: InviteValues) => {
		const supplierFacilityId = nullSafeGetOrElse('id', supplierFacility, null);
		if (!supplierFacilityId) {
			return;
		}
		setSubmitting(true);
		inviteSupplierUser(
			supplierFacilityId,
			currentUser.email,
			values.primaryContactEmail,
			values.primaryContactFirstName,
			values.primaryContactLastName
		)
			.then(() => {
				message.success(
					`${values.primaryContactFirstName} ${values.primaryContactLastName} has been sent an invite to join OpenWrench at the email address: ${values.primaryContactEmail}`
				);
				onInvited(values);
			})
			.catch((errMessage) => {
				message.error(errMessage || 'Could not send invite. Please try again.');
			})
			.finally(() => setSubmitting(false));
	};

	return (
		<SelfManagedSupplierInvitationForm
			visible={visible}
			supplierFacility={supplierFacility}
			onCancel={onCancel}
			onSkip={onSkip}
			onSubmit={handleSubmit}
			loading={submitting}
			showContext={showContext}
		/>
	);
};

const mapStateToProps = (state: any) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
	inviteSupplierUser: (
		supplierFacilityId: number,
		fromEmail: string,
		toEmail: string,
		firstName: string,
		lastName: string
	) =>
		dispatch(
			inviteSupplierUserFromBuyer(ownProps.userType)(
				supplierFacilityId,
				fromEmail,
				toEmail,
				firstName,
				lastName
			)
		),
});

const InnerConnected = connect(
	mapStateToProps,
	mapDispatchToProps
)(SelfManagedSupplierEmailPromptModal as any);

export default connect(
	(state: any) => ({ userType: state.session.userType }),
	() => ({})
)(InnerConnected);
